// test912
(912 && 0);
